import React from 'react';
import { Card, Tag } from 'antd';
import TextArea from 'antd/es/input/TextArea';

const RecoveryPlanSummary = ({
	selectedSummarySections = [],
	selectedGoalStatement = {},
	selectedAreaComprehensiveEvaluation = {},
	options = [],
	showTextArea = false,
	onChangeAnswer = () => {},
	result = {},
	esign = false
}) => {
	return (
		<div className="text-sm">
			<div className="mb-2 font-semibold italic underline text-base">Summary</div>
			<div className='flex flex-col gap-4 sm:gap-6'>
				{options?.map((val) => {
				const goalResult = selectedSummarySections.includes(val.key)
					? selectedGoalStatement[val.key]?.map(item => item.label).join(' ')
					: null;
				const areaResult = selectedSummarySections.includes(val.key)
					? selectedAreaComprehensiveEvaluation[val.key]?.map(item => item.label).join(' ')
					: null;

				if (!goalResult && !areaResult) return null;

				return (
					<div
						key={val.key}
					>
						<div className="text-sm font-semibold mb-2">{val?.topic}</div>
						<div className="space-y-2">
							<div className="flex gap-2">
								<span className="font-medium min-w-[60px]">Areas:</span>
								<div className="flex-1">
									{areaResult && (
										<Tag className="text-sm whitespace-normal mr-0">{areaResult}</Tag>
									)}
								</div>
							</div>

							<div className="flex gap-2">
								<span className="font-medium min-w-[60px]">Goal:</span>
								<div className="flex-1">
									{goalResult && (
										<Tag className="text-sm whitespace-normal mr-0">{goalResult}</Tag>
									)}
								</div>
							</div>
							{
								showTextArea && (
									<div className="flex gap-2">
										<span className="font-medium min-w-[60px]">Result:</span>
										<div className="flex-1">
											<TextArea value={result[val?.key] || ""} onChange={(e)=>onChangeAnswer(e.target.value,val.key)} disabled={esign}/>
										</div>
									</div>
								)
							}
						</div>
					</div>
				);
			})}
			</div>
		</div>
	);
};

export default RecoveryPlanSummary;
